module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av326-9c27d5db78f6b1be0e4198d2d7ab18bd.jpg";